import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
export function Guarantee() {
  return <section className="bg-white px-5 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-198" data-mp="20m4phsgugev0">
      <div className="mx-auto max-w-3xl text-center" data-id="element-199" data-mp="24mex19kabdbz">
        <ShieldCheckIcon className="mx-auto h-16 w-16 text-electric" strokeWidth={1.75} aria-hidden="true" data-id="element-200" data-mp="29doj606mjyj4" />
        <p className="mt-3 font-display text-sm font-extrabold uppercase text-electric" data-id="element-201" data-mp="2edja23qego46">Your purchase, with clear terms</p>
        <h2 id="guarantee-title" className="mt-1 font-display text-[28px] font-black uppercase leading-tight text-navy-950 sm:text-4xl" data-id="element-202" data-mp="2jb1na6bg9phz">
          Buy with confidence
        </h2>
        <div className="mt-6 space-y-4 text-base leading-relaxed text-ink/75 sm:text-lg" data-id="element-203" data-mp="2sdatijzoqwpk">
          <p className="font-semibold text-navy-950" data-id="element-204" data-mp="txfzu7gmfzx8">I want you to know exactly what you’re purchasing.</p>
          <p data-id="element-205" data-mp="xy8an5556cvm">
            MAXILLARY GROWTH BLUEPRINT™ is a digital educational collection containing six volumes and five
            complementary resources, designed to support professional learning and structured clinical reasoning.
          </p>
          <p data-id="element-206" data-mp="3ntf2m9g4icfr">
            They do not replace accredited specialty training, independent professional judgment, appropriate
            diagnostic records, or patient-specific treatment planning.
          </p>
        </div>
        <div className="mt-6 rounded-2xl bg-mist px-5 py-4 text-left text-[15px] leading-snug text-ink" data-id="element-207" data-mp="fewobpzla0np">
          <strong className="text-navy-950" data-id="element-208" data-mp="afts8v1l74rv">Refund policy:</strong> the applicable refund terms are displayed at
          checkout so you can review them before completing your purchase.
        </div>
        <div className="mt-9" data-id="element-209" data-mp="hnqcdfs5yn0">
          <CtaButton label="Get the complete blueprint for $27" data-id="element-210" data-mp="gm5jh8ypxs3" />
        </div>
      </div>
    </section>;
}